<div class="access-wrapper">
    <h1>{{data.title}}</h1>
    <div class="align-icon">
        <mat-icon>
            {{data.icon}}
        </mat-icon>
    </div>
    <h3 [innerHTML]="data.description">
    </h3>
</div>